"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { key: 2 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_CardRenderItemComponent = (0, vue_1.resolveComponent)("CardRenderItemComponent");
    const _component_CardRenderSymbolComponent = (0, vue_1.resolveComponent)("CardRenderSymbolComponent");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        class: (0, vue_1.normalizeClass)(_ctx.getClasses())
    }, [
        ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.rows, (rowData, index) => {
            return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                class: "card-production-box-row",
                key: index
            }, [
                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(rowData, (rowItem, rowIndex) => {
                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                        class: "card-production-box-row-item",
                        key: rowIndex
                    }, [
                        (rowItem && typeof rowItem === 'object' && rowItem.is === 'item')
                            ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderItemComponent, {
                                key: 0,
                                item: rowItem
                            }, null, 8, ["item"]))
                            : (rowItem && typeof rowItem === 'object' && rowItem.is === 'symbol')
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_CardRenderSymbolComponent, {
                                    key: 1,
                                    item: rowItem
                                }, null, 8, ["item"]))
                                : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, "n/a"))
                    ]));
                }), 128))
            ]));
        }), 128))
    ], 2));
}
